import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';

import { AdminService } from '../../../../../core/services/admin.service';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { LanguageTranslationService } from '../../../../../core/services/language-translation.service';
import { FileRestrictions } from '@progress/kendo-angular-upload';
import { environment } from '../../../../../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-customer-specific-school-admin',
  templateUrl: './customer-specific-school-admin.component.html',
  styleUrls: ['./customer-specific-school-admin.component.scss']
})
export class CustomerSpecificSchoolAdminComponent implements OnInit {
  description: string = "";
  userLanguage: string = "";
  enableText: boolean = false;
  id: any;
  getLanguages: any;
  trainingForm: FormGroup;
  selectedLanguage: string = "";
  constructor(private adminService: AdminService, private formBuilder: FormBuilder, private appNotifyService: AppNotifyService,
    private languageService: LanguageTranslationService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.trainingForm = this.formBuilder.group({
      id: new FormControl(0),
      description: new FormControl(""),
      languageCode: new FormControl(""),     
    })
    this.languageService.getLanguages().subscribe(response => {
      this.getLanguages = response;
    })
    this.selectedLanguage = localStorage.getItem('language');
    this.lanaguageChange("");
  }

  //#region label/variable declaration
  public customerSpecificSchool = {
    languageLbl: 'Language',
    descriptionLbl: 'Description',
    isSubmitted: false,
    isLanguageCodeEmpty: false,
    isDescriptionEmpty: false,
    isEmptyCustomerSpecificSchoolUrlPath: false 
  }
  customerSpecificSchoolUrlPath: string = null;
  customerSpecificSchoolUrl: any = null;
  customerSpecificSchoolInputMethod: string = "TextEditor";
  //#endregion
  //#region save/cancel button operations
  lanaguageChange(event) {
    const body = {
      trainingType: "customerSpecificSchool",
      languageCode: event ? event.languageCode : this.selectedLanguage
    }
    this.customerSpecificSchool.isLanguageCodeEmpty = false;
    this.adminService.getTrainingPagesDescription(body).subscribe(response => {
      this.enableText = true;
      if (response.length > 0) {
       
        this.trainingForm.controls.id.setValue(response[0].trainingId);
        this.customerSpecificSchool.isDescriptionEmpty = false;
        this.transformCustomerSpecificSchool(response[0])
        this.trainingForm.controls.description.setValue(response[0].description);
      } else {
        this.trainingForm.controls.description.reset();
      }
    })
  }
  transformCustomerSpecificSchool(customerSpecificSchool: any) {

    if (customerSpecificSchool) {
      if (customerSpecificSchool.urlPath) {
        this.customerSpecificSchoolUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.imageUrl + customerSpecificSchool.urlPath);
        this.customerSpecificSchoolInputMethod = "FileUpload";       
      } else {
        this.customerSpecificSchoolInputMethod = "TextEditor";
        this.customerSpecificSchoolUrl = null;
      }
    }
  }
  public validateCustomerSpecificSchoolForm(): boolean {
    let isValid = true;
    const controls = this.trainingForm.controls;
    if (this.customerSpecificSchool.isSubmitted) {
      if (controls.languageCode.value) {
        this.customerSpecificSchool.isLanguageCodeEmpty = false;
      } else {
        this.customerSpecificSchool.isLanguageCodeEmpty = true;
        isValid = false;
      }

      if (this.customerSpecificSchoolInputMethod === "FileUpload") {
        if (this.customerSpecificSchoolUrlPath) {
          this.customerSpecificSchool.isEmptyCustomerSpecificSchoolUrlPath = false;
        } else {
          this.customerSpecificSchool.isEmptyCustomerSpecificSchoolUrlPath = true;
          isValid = false;
        }
      } else {
        if (controls.description.value) {
          this.customerSpecificSchool.isDescriptionEmpty = false;
        } else {
          this.customerSpecificSchool.isDescriptionEmpty = true;
          isValid = false;
        }
      }
     
    }
    return isValid;
  }

  resetForm() {
    this.trainingForm.reset();
    this.enableText = false;
    this.customerSpecificSchool.isSubmitted = false;
    this.customerSpecificSchool.isLanguageCodeEmpty = false;
    this.customerSpecificSchool.isDescriptionEmpty = false;
    this.customerSpecificSchool.isEmptyCustomerSpecificSchoolUrlPath = false;
    this.selectedLanguage = "";
    this.customerSpecificSchoolUrlPath = null;
    this.customerSpecificSchoolUrl = null;
    this.customerSpecificSchoolInputMethod = "TextEditor";

  }
  saveCustomerSpecificSchool() {
    this.customerSpecificSchool.isSubmitted = true;
    if (!this.validateCustomerSpecificSchoolForm()) {
      return;
    }
    if (this.customerSpecificSchoolInputMethod === "FileUpload") {
      if (!this.customerSpecificSchoolUrlPath) {
        this.customerSpecificSchoolUrlPath = null;
      }
    } else {
      this.customerSpecificSchoolUrlPath = null;
    }
    const controls = this.trainingForm.controls;
      const body = {
        description: controls.description.value,
        trainingId: controls.id.value,
        trainingType: "customerSpecificSchool",
        languageCode: controls.languageCode.value ? controls.languageCode.value.languageCode : localStorage.getItem('language'),
        urlPath: this.customerSpecificSchoolUrlPath
      }
      this.adminService.saveTrainingPagesDescription(body).subscribe(response => {
        //this.resetForm();
        this.selectedLanguage = body.languageCode;
        this.lanaguageChange("");
        this.appNotifyService.notify(NotifyType.SUCCESS, 'Saved successfully!');
      })

  }
  fileRestrictions: FileRestrictions = {
    allowedExtensions: [".pdf"],
  };
  customerSpecificSchoolSelected(event) {
    console.log(event);
  }
  customerSpecificSchoolUploadSuccess(event) {
    console.log(event);
    this.customerSpecificSchoolUrlPath = event.response.body.paths[0];
    if (this.customerSpecificSchoolUrlPath) {
      const url = environment.imageUrl + `/api/${this.customerSpecificSchoolUrlPath}`;
      this.customerSpecificSchoolUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url.replace("\\", "/"));
      this.customerSpecificSchoolInputMethod = "FileUpload";
    } else {
      this.customerSpecificSchoolInputMethod = "TextEditor";
    }

  }
  //#endregion
}
